export default "__VITE_ASSET__Dxiz11sa__"